import _ from '@utils/store-helpers';
import authService from '@services/auth.service';
import usersService from '@services/api/Users';
import swal from 'sweetalert';
/* eslint no-console: ["error", { allow: ["error"] }] */
const isAuthenticationEnabled = JSON.parse(process.env.VUE_APP_authentication_enabled);

export const state = {
  user: _.get('user'),
  roles: _.get('roles'),
};

export const mutations = {
  SET_CURRENT_USER: _.set('user', true),
  SET_CURRENT_ROLES: _.set('roles', true),
};

export const getters = {
  loggedIn(state) {
    return state.user != null;
  },

  userInRole: (state) => (roleName) => {
    if (state.roles === null) {
      return false;
    }

    return state.roles.filter((role) => {
      return role.displayName === roleName;
    });
  },
  
  hasClientId: (state) => {
    return state.clientId != null && state.clientId.length > 0;
  },

  getUserRoles(state) {
    return state.roles;
  },

};

export const actions = {
  resetSettings({ commit }) {
    commit('SET_CURRENT_ROLES', null);
    commit('SET_CURRENT_USER', null);
  },
  
  async getUser({ commit, dispatch }) {
    try {
      var adalUser = '';
      if (isAuthenticationEnabled) {
        adalUser = authService.getUser();
      } else {
        adalUser = {
          idToken: { name: "Keren Man", emails: ["kman@qw-corp.com"], family_name: "Man", given_name: "Keren",}
        }
      }
      if (adalUser) {
        const user = {
          name: adalUser.idToken.name,
          email:
            (adalUser.idToken.emails && adalUser.idToken.emails.length > 0)
              ? adalUser.idToken.emails[0]
              : '',
          lastName: adalUser.idToken.family_name,
          firstName: adalUser.idToken.given_name,
        };
                
        //leave below mock here for testing purpose        
        // const activeUser = {'email': 'kman@qw-corp.com', 'roles': [{'objectId': 'e044bd90-287d-43fe-9298-23def36a1331', 'displayName': 'Taz-Admin'}]};
        const rolesResponse = await usersService.getUserRoles();
        const activeUser = rolesResponse.data;
        activeUser.isAdmin = (activeUser.roles && activeUser.roles.some((x) => x.displayName === 'Taz-Admin'));
        activeUser.isMedia = (activeUser.roles && activeUser.roles.some((x) => x.displayName === 'Taz-Media'));
        activeUser.isAffiliate = (activeUser.roles && activeUser.roles.some((x) => x.displayName === 'Taz-Affiliate'));
        activeUser.isTaz = (activeUser.roles && activeUser.roles.some((x) => x.displayName === 'Taz'));
        activeUser.isReporting = (activeUser.roles && activeUser.roles.some((x) => x.displayName === 'Taz-Reporting'));
        var newUser = Object.assign({}, user, activeUser);  
        if(activeUser.isAffiliate || activeUser.isTaz ){
          let partnerID = await dispatch('getPartnerIDByAffiliateEmail',(activeUser.email));
          newUser.partnerID = partnerID;
        }
        commit('SET_CURRENT_ROLES', activeUser.roles);
        commit('SET_CURRENT_USER', newUser);        
        
        return newUser;
      } else {
        dispatch('resetSettings');
        return null;
      }
    } catch (err) {
      swal({title: 'Error occured while calling getUser method ', text: err.message, icon: 'error', button: true, dangerMode: true,});
      dispatch('resetSettings');
      console.error(err);
      return null;
    }
  },

  async getToken() {
    return authService.getToken();
  },

  async getPartnerIDByAffiliateEmail(commit, email){
    const partnerEmailResponse = await usersService.getPartnerIDByAffiliateEmail(email);
    return partnerEmailResponse.data;
  },

  async logIn({ dispatch } = {}) {
    try {
      const adalUser = await authService.login();

      if (adalUser) {
        await dispatch('getUser');
      } else {
        dispatch('resetSettings');
        return null;
      }
    } catch (err) {
      console.error(err);
    }
  },

  logOut({ dispatch }) {
    dispatch('resetSettings');
    authService.logOut();
  },

};
